import { useState, createContext, useEffect } from 'react'
import { IntlProvider } from 'react-intl'
import Api from 'src/api'
import Spinner from 'src/core/components/spinner/Fallback-spinner'
import { useDispatch, useSelector } from 'react-redux'
import _ from 'lodash'

const Context = createContext()

const IntlProviderWrapper = ({ children }) => {
	const dispatch = useDispatch()
	const { locale } = useSelector((store) => store.auth)
	const [loading, setLoading] = useState(true)
	const [messages, setMessages] = useState({})

	useEffect(() => {
		setLoading(true)
		Api.getLanguageWordsList({ code: locale ? locale : 'en' })
			.then(({ data }) => {
				const messages = _.reduce(
					data?.data,
					(acc, item) => ({
						...acc,
						[item.key]: item.value,
					}),
					{},
				)
				setMessages(messages)
				setLoading(false)
			})
			.catch((error) => {
				setLoading(false)
			})
	}, [locale])

	const switchLanguage = (lang) => {
		dispatch({ type: 'LOCALE', data: lang })
	}

	const errorHandler = (e) => {}

	if (loading) {
		return <Spinner />
	} else {
		return (
			<Context.Provider value={{ locale, switchLanguage }}>
				<IntlProvider key={locale} locale={locale} onError={errorHandler} messages={messages} defaultLocale='en'>
					{children}
				</IntlProvider>
			</Context.Provider>
		)
	}
}

export { IntlProviderWrapper, Context as IntlContext }
